import { render, staticRenderFns } from "./PVReEditDialog.vue?vue&type=template&id=66066882"
import script from "./PVReEditDialog.vue?vue&type=script&lang=js"
export * from "./PVReEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports